<div class="container-fluid">

    <div class="groupComponentHeading" *ngIf="groupPortalDataService.groupList.groupInvoices.length > 0">
        <div class="col-5 members">Transaction History</div>
    </div>

    <div class="result-grid col-12 px-4">
        <div class="row headerRow">
            <div class="col-md-4 sort">
                <a class="{{groupPortalDataService.invoicesSortedBy == 'date' ? (groupPortalDataService.sortInvoiceDateAscending ? 'sortAsc' : 'sortDesc') : 'sortArrow' }}"
                    (click)="changeSortDate()"><strong>Date</strong></a>
            </div>
            <div class="col-md sort d-flex">
                <a class="{{groupPortalDataService.invoicesSortedBy == 'GBNumber' ? (groupPortalDataService.sortGBNumberAscending ? 'sortAsc' : 'sortDesc') : 'sortArrow' }}"
                    (click)="changeSortGBNumber()"><strong>Group Bill Number</strong></a>
            </div>
            <div class="col-md-2 sort d-flex justify-content-end pr-md-3">
                <a class="{{groupPortalDataService.invoicesSortedBy == 'amount' ? (groupPortalDataService.sortInvoiceAmountAscending ? 'sortAsc' : 'sortDesc') : 'sortArrow' }}"
                    (click)="changeSortAmount()"><strong>Amount</strong></a>
            </div>
        </div>

        <div class="row groupMembers invoicehistory"
            *ngFor="let invoice of groupPortalDataService.groupList.groupInvoices">
            <div class="col-md-4">
                {{SantizeDate(invoice.date)}}
            </div>
            <div class="col-md">
                {{invoice.groupBillNumber}}
            </div>
            <div class="col-md-2 sort d-flex justify-content-end pr-md-3">
                <strong>{{invoice.amount | currency:'USD':'symbol-narrow':'1.2-2'}}</strong>
            </div>
        </div>
        <div class="row cardInfo mt-5" *ngIf="groupPortalDataService.groupList.groupInvoices?.length < 1">
            <div class="col-12">
                <i>Currently No Invoices to Display</i>
            </div>
        </div>
    </div>

    <!-- <div class="row">
        <div class="col-12 subTitle"><strong>Group Info</strong></div>
    </div>

    <div class="FlowupLabels">
        <div class="fl_wrap" [ngClass]="{'populated' : groupPortalDataService.groupList.GroupInfo?.name}">
            <label class="fl_label" for="groupName">Group Name</label>
            <input class="fl_input" disabled name="groupName" type="textbox" placeholder="" [(ngModel)]="groupPortalDataService.groupList.GroupInfo.name">
        </div>
        <div class="fl_wrap" [ngClass]="{'populated' : groupPortalDataService.groupList.GroupInfo.country}">
            <label class="fl_label" for="Country">Country</label>
            <select class="fl_input" name="Country" disabled [(ngModel)]="groupPortalDataService.groupList.GroupInfo.country" (change)="onCountrySelect($event.target.value)" required="required">
					<option value=""></option>
					<option *ngFor="let obj of dataService.uidata?.Countries" [value]="obj.acep_iso2code">{{obj.acep_name}}</option>
				</select>
            <span class="validationhead">Required</span>
        </div>
        <div class="fl_wrap" [ngClass]="{'populated' : groupPortalDataService.groupList.GroupInfo.name}">
            <label class="fl_label" for="groupName">Attention</label>
            <input class="fl_input" disabled name="groupName" type="textbox" placeholder="" [(ngModel)]="groupPortalDataService.groupList.GroupInfo.name">
        </div>
        <div class="fl_wrap" [ngClass]="{'populated' : groupPortalDataService.groupList.GroupInfo.street}">
            <label class="fl_label" for="street">Street</label>
            <input class="fl_input" disabled name="street" type="textbox" placeholder="" [(ngModel)]="groupPortalDataService.groupList.GroupInfo.street">
        </div>
        <div class="fl_wrap" [ngClass]="{'populated' : groupPortalDataService.groupList.GroupInfo.city}">
            <label class="fl_label" for="city">City</label>
            <input class="fl_input" disabled name="city" type="textbox" placeholder="" [(ngModel)]="groupPortalDataService.groupList.GroupInfo.city">
        </div>
        <div class="fl_wrap" [ngClass]="{'populated' : groupPortalDataService.groupList.GroupInfo.state}">
            <label class="fl_label" for="StateProvince">State/Province</label>
            <select class="fl_input" name="StateProvince" disabled [(ngModel)]="groupPortalDataService.groupList.GroupInfo.state" required="required">
					<option value=""></option>
					<option *ngFor="let obj of ui_stateprovinces" [value]="obj.acep_isocode">{{obj.acep_name}}</option>
				</select>
        </div>
        <div class="fl_wrap" [ngClass]="{'populated' : groupPortalDataService.groupList.GroupInfo.zip}">
            <label class="fl_label" for="zip">Zip/Postal Code</label>
            <input class="fl_input" disabled name="zip" type="textbox" placeholder="" [(ngModel)]="groupPortalDataService.groupList.GroupInfo.zip">
        </div>
        <div class="fl_wrap" [ngClass]="{'populated' : groupPortalDataService.groupList.GroupInfo.mainPhone}">
            <label class="fl_label" for="mainPhone">Phone</label>
            <input class="fl_input" disabled name="mainPhone" type="textbox" placeholder="" [(ngModel)]="groupPortalDataService.groupList.GroupInfo.mainPhone">
        </div>
        <div class="fl_wrap" [ngClass]="{'populated' : groupPortalDataService.groupList.GroupInfo.email}">
            <label class="fl_label" for="email">Email</label>
            <input class="fl_input" disabled name="email" type="textbox" placeholder="" [(ngModel)]="groupPortalDataService.groupList.GroupInfo.email">
        </div>
        <div class="fl_wrap icon-nav" [ngClass]="{'populated' : groupPortalDataService.groupList.GroupInfo.webSite}">
            <a class="icon-globe"></a>
            <label class="fl_label" for="webSite">Website</label>
            <input class="fl_input" disabled name="webSite" type="textbox" placeholder="" [(ngModel)]="groupPortalDataService.groupList.GroupInfo.webSite">
        </div>
        <div class="fl_wrap icon-nav" [ngClass]="{'populated' : groupPortalDataService.groupList.GroupInfo.facebook}">
            <a class="fbselect"></a>
            <label class="fl_label" for="facebook">Facebook</label>
            <input class="fl_input" disabled name="facebook" type="textbox" placeholder="" [(ngModel)]="groupPortalDataService.groupList.GroupInfo.facebook">
        </div>
        <div class="fl_wrap icon-nav" [ngClass]="{'populated' : groupPortalDataService.groupList.GroupInfo.twitter}">
            <a class="twselect"></a>
            <label class="fl_label" for="twitter">Twitter</label>
            <input class="fl_input" disabled name="twitter" type="textbox" placeholder="" [(ngModel)]="groupPortalDataService.groupList.GroupInfo.twitter">
        </div>
    </div> -->

</div>